import { __extends } from "tslib";
import { axCoerceString } from '@awayjs/graphics';
import { Event } from './Event';
var ThrottleEvent = /** @class */ (function (_super) {
    __extends(ThrottleEvent, _super);
    function ThrottleEvent(type, bubbles, cancelable, state, targetFrameRate) {
        if (bubbles === void 0) { bubbles = false; }
        if (cancelable === void 0) { cancelable = false; }
        if (state === void 0) { state = null; }
        if (targetFrameRate === void 0) { targetFrameRate = 0; }
        var _this = _super.call(this, type, bubbles, cancelable) || this;
        _this.state = axCoerceString(state);
        _this.targetFrameRate = +targetFrameRate;
        return _this;
    }
    ThrottleEvent.classInitializer = null;
    ThrottleEvent.classSymbols = null;
    ThrottleEvent.instanceSymbols = null;
    // JS -> AS Bindings
    ThrottleEvent.THROTTLE = 'throttle';
    return ThrottleEvent;
}(Event));
export { ThrottleEvent };
